import { Controller } from "@hotwired/stimulus"

// Swaps the membership-plan visit copy between a top up that keeps adding
// visits and a monthly start that resets on the 1st.
export default class extends Controller {
  static targets = ["mode", "billingHelp", "calendarHelp", "billingVisitsLabel", "calendarVisitsLabel"]

  connect() {
    this.sync()
  }

  modeChanged() {
    this.sync()
  }

  sync() {
    const calendar = this.selected === "calendar_month"
    this.toggle(this.billingHelpTargets, !calendar)
    this.toggle(this.calendarHelpTargets, calendar)
    this.toggle(this.billingVisitsLabelTargets, !calendar)
    this.toggle(this.calendarVisitsLabelTargets, calendar)
  }

  toggle(elements, show) {
    elements.forEach((element) => element.classList.toggle("hidden", !show))
  }

  get selected() {
    const checked = this.modeTargets.find((element) => element.checked)
    return checked?.value || "billing_period"
  }
}
